import { TransactionStatus } from '@/constants'

const processingStatuses = [
  TransactionStatus.accepted,
  TransactionStatus.approval,
  TransactionStatus.pending,
  TransactionStatus.pendingPayee,
  TransactionStatus.requested,
]

export default {
  methods: {
    getStatusClass(status: TransactionStatus): string {
      const userFacingStatus = this.getStatusText(status)

      return userFacingStatus === TransactionStatus.paid
        ? 'text-success'
        : userFacingStatus === TransactionStatus.processing
          ? 'text-blue-alternate'
          : 'text-error'
    },
    getStatusText(status: TransactionStatus): string {
      return processingStatuses.includes(status)
        ? 'Processing'
        : (status || '')
    },
  },
}
